import type { ComponentType } from "react";

/**
 * Chakra v3 slot components use `forwardAsChild` typings that omit `children`.
 * Cast to a permissive component type for v2-compat wrappers.
 */
export function asSlotComponent<T>(component: T): ComponentType<any> {
  return component as ComponentType<any>;
}
